module.exports = __webpack_public_path__ + "img/Frame4368.80e6a393.png";